var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{class:['eui-a-divider', { '-secondary': _vm.secondary }, { '-inset': _vm.inset }, { '-vertical': _vm.vertical } ],attrs:{"role":"separator"}})
}
var staticRenderFns = []

export { render, staticRenderFns }